import React from 'react';
import PropTypes from 'prop-types';

import {Box, Flex, Skeleton, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import SelectorTile from '@amblique/king-living/app/components/configuration-selector/selector-tile';

const SKELETON_COUNT = 4;

/**
 * Scrollable vertical stack of configuration product tiles (radio group).
 * Shows skeleton loading state while data is being fetched.
 */
const SelectorList = ({products, isLoading, selectedId, onSelect, onViewDetails}) => {
  const styles = useMultiStyleConfig('ConfigurationSelector', {});

  if (isLoading) {
    return (
      <Box className="choose-your-layout-list" {...styles.list}>
        {Array.from({length: SKELETON_COUNT}).map((_, i) => (
          <Flex key={i} {...styles.tile}>
            <Skeleton
              borderRadius="0"
              flexShrink={0}
              height="60px"
              width="76px"
            />
            <Box flex={1} minWidth={0} paddingLeft={4}>
              <Skeleton height="14px" width="80%" />
              <Skeleton height="12px" marginTop={2} width="60%" />
            </Box>
            <Box flexShrink={0} paddingLeft={4} textAlign="right">
              <Skeleton height="12px" width="40px" />
              <Skeleton height="14px" marginTop={1} width="60px" />
            </Box>
            <Skeleton borderRadius="full" flexShrink={0} height="32px" marginLeft={2} width="32px" />
          </Flex>
        ))}
      </Box>
    );
  }

  if (!products.length) {
    return null;
  }

  return (
    <Box className="choose-your-layout-list" {...styles.list} role="radiogroup">
      {products.map((hit) => {
        const id = hit.productId || hit.id;

        return (
          <SelectorTile
            key={id}
            className="choose-your-layout-tile"
            hit={hit}
            isSelected={selectedId === id}
            onSelect={onSelect}
            onViewDetails={onViewDetails}
          />
        );
      })}
    </Box>
  );
};

SelectorList.displayName = 'SelectorList';

SelectorList.propTypes = {
  products: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  selectedId: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onViewDetails: PropTypes.func,
};

export default SelectorList;
